"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));

var _constants = require("../../constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _makeStyles.default)(theme => ({
  selectContainer: {
    width: '100%',
    marginBottom: theme.spacing(1)
  },
  searchPlaceholderText: {
    color: _constants.colours.inactiveState
  },
  searchText: {
    fontSize: _constants.fontSizes.subtitle2,
    fontWeight: 'bold',
    color: _constants.colours.font
  },
  searchIconContainer: {
    borderLeft: `solid 1px ${_constants.colours.activeFilter}`,
    height: 50,
    minWidth: 50,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  inputContainer: {
    width: '100%',
    height: '100%'
  }
}));
const StyledInput = (0, _core.withStyles)(() => ({
  root: {
    paddingRight: 0,
    height: 50,
    backgroundColor: _constants.colours.white
  },
  notchedOutline: {// borderColor: `${colours.activeFilter} !important`
  }
}))(_core.OutlinedInput);
const StyledSelect = (0, _core.withStyles)(() => ({
  root: {
    padding: 15,
    backgroundColor: _constants.colours.white
  },
  iconOutlined: {
    width: 34,
    borderColor: _constants.colours.activeFilter
  }
}))(_core.Select);
const StyledMenuItem = (0, _core.withStyles)(() => ({
  root: {
    '&:focus': {
      backgroundColor: _constants.colours.white,
      '&:hover': {
        backgroundColor: _constants.colours.lightGrey
      }
    },
    '&:hover': {
      color: _constants.colours.font,
      backgroundColor: _constants.colours.lightGrey
    },
    '&.Mui-selected': {
      backgroundColor: _constants.colours.multiSelect,
      color: _constants.colours.white
    },
    padding: '15px 20px'
  }
}))(_core.MenuItem);
const MenuProps = {
  PaperProps: {
    style: {
      borderRadius: 2,
      boxShadow: _constants.shadows.paperContainer
    }
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
};

const SearchBarMobile = ({
  handleSelectChange,
  handleSubmit,
  handleInputChange,
  currentOption,
  currentSearchTerm,
  options
}) => {
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "filled",
    className: classes.selectContainer
  }, /*#__PURE__*/_react.default.createElement(StyledSelect, {
    value: currentOption,
    onChange: handleSelectChange,
    IconComponent: _ExpandMore.default,
    variant: "outlined",
    displayEmpty: true,
    MenuProps: MenuProps,
    renderValue: value => {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: value === '' ? classes.searchPlaceholderText : classes.searchText
      }, value === '' ? 'Search by category...' : options[value].label);
    }
  }, options.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement(StyledMenuItem, {
      key: el.value,
      value: index
    }, el.label);
  }))), /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "filled",
    className: classes.inputContainer
  }, /*#__PURE__*/_react.default.createElement(StyledInput, {
    value: currentSearchTerm,
    disabled: currentOption === '',
    placeholder: "Enter search term...",
    onChange: handleInputChange,
    endAdornment: /*#__PURE__*/_react.default.createElement("div", {
      className: classes.searchIconContainer
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      onClick: currentOption === '' ? () => null : handleSubmit
    }))
  })));
};

SearchBarMobile.propTypes = {
  handleSelectChange: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  handleInputChange: _propTypes.default.func.isRequired,
  currentOption: _propTypes.default.string.isRequired,
  currentSearchTerm: _propTypes.default.string.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};

var _default = (0, _withWidth.default)()(SearchBarMobile);

exports.default = _default;